export const SECRET_DATE = '06/23/2026';
export const SECRET_PASSWORD = 'capcapcap';
export const SECRET_STORAGE_KEY = 'caroline-062326-unlocked';
